export default {
  "content": "<rect width=\"36\" height=\"36\" fill=\"#E6F2EC\" rx=\"18\"/><path fill=\"#007F41\" fill-rule=\"evenodd\" d=\"M18 28.5c5.799 0 10.5-4.701 10.5-10.5S23.799 7.5 18 7.5 7.5 12.201 7.5 18 12.201 28.5 18 28.5zm5.413-12.942a1.05 1.05 0 00-1.551-1.416l-5.647 6.188-2.022-2.022a1.05 1.05 0 00-1.486 1.485l2.736 2.735a1.138 1.138 0 001.644-.038l6.326-6.932z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "36",
    "height": "36",
    "fill": "none",
    "viewBox": "0 0 36 36"
  }
};